module.exports = __webpack_public_path__ + "media/application/images/demsoc/cyber_essentials-0ce91e3e082365d18b98e9300d53782d.png";